import App from "./app";
import OrderDetail from "@/shared/models/entities/order-detail";
import School from "@/shared/models/entities/school";
import SchoolClass from '@/shared/models/entities/school-class';
import Grade from '@/shared/models/enums/grade';
import IsPending from '@/shared/models/enums/is-pending';
import { isNud } from '@/shared/utilities/typing';
import { dateYmd } from '@/shared/utilities/date-format';

/**
 * アカウントユーザー エンティティ
 */
class AccountUser {
    account_user_id;
    school;
    year;
    grade;
    school_class;
    order_detail;
    license_id;
    app;
    student_number;
    student_name;
    is_pending;
    login_key;
    login_code;
    latest_signin_datetime;


    constructor(properties) {
        if (isNud(properties)) {
            properties = {};
        }

        this.account_user_id = properties.account_user_id;
        this.school = new School(properties.school);
        this.year = properties.year;
        this.grade = properties.grade;
        this.school_class = new SchoolClass(properties.school_class);
        this.order_detail = new OrderDetail(properties.order_detail);
        this.license_id = properties.license_id;
        this.app = new App(properties.app);
        this.student_number = properties.student_number;
        this.student_name = properties.student_name;
        this.is_pending = properties.is_pending;
        this.login_key = properties.login_key;
        this.login_code = properties.login_code;
        this.latest_signin_datetime = properties.latest_signin_datetime;
    }

    get grade_display() {
        return Grade.getWhereSchoolType(this.school.school_type, this.grade);
    }

    get student_name_display() {
        return isNud(this.student_name) ? this.student_number : this.student_name;
    }

    get is_pending_display() {
        return IsPending.get(this.is_pending);
    }

    get latest_signin_datetime_display() {
        return this.latest_signin_datetime ? dateYmd(this.latest_signin_datetime) : ' - ';
    }

}

export default AccountUser;
